import React from "react";

function Footer(props) {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row">
          <div className="mx-auto">
            <h5>&copy;MMXXI A Swing of the Angst Production.</h5>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
